<template>
  <v-row class="inner-content">
    <v-col>

      <v-card class="pt-2 pl-5 elevation-0">

          <v-tabs v-model="tab" @change="tabChanged">
            <v-tab v-for="item in items" :key="item">{{ item }}</v-tab>
          </v-tabs>

          <v-tabs-items v-model="tab">
            <v-tab-item>
              <BingCampaigns v-if="tab == 0"></BingCampaigns>
            </v-tab-item>
            <v-tab-item>
              <BingKeywords v-if="tab == 1"></BingKeywords>
            </v-tab-item>
            <v-tab-item>
              <BingRSAs v-if="tab == 2"></BingRSAs>
            </v-tab-item>
            <v-tab-item>
              <BingExtensions v-if="tab == 3"></BingExtensions>
            </v-tab-item>
          </v-tabs-items>

      </v-card>

    </v-col>
  </v-row>
</template>

<script>
export default {
  name: 'BingBase',

  data () {
    return {
      tab: null,
      items: ['Campaigns', 'Keywords', 'RSAs', 'Extensions'],
      lsTab: 'bingBase_tab',
    }
  },

  components: {
    BingCampaigns: () => import('@/components/contentCreator/BingCampaigns.vue'),
    BingExtensions: () => import('@/components/contentCreator/BingExtensions.vue'),
    BingKeywords: () => import('@/components/contentCreator/BingKeywords.vue'),
    BingRSAs: () => import('@/components/contentCreator/BingRSAs.vue'),
  },

  methods: {
    tabChanged () {
      localStorage.setItem(this.lsTab, JSON.stringify(this.tab))
    },
  },

  created: function () {
    if (localStorage.getItem(this.lsTab)) {
      this.tab = JSON.parse(localStorage.getItem(this.lsTab))
    }
  },
}
</script>

<style scoped>
</style>